import cn from "classnames";
import styles from "./Tabs.module.scss";

interface ITabsPanelProps {
  tabIndex?: number;
  className?: string;
  "data-tab": string;
}

export const TabsPanel: RFC<ITabsPanelProps> = ({ className, children }) => {
  return <div className={cn(styles.panel, className)}>{children}</div>;
};

TabsPanel.displayName = "TabsPanel";
